export const LOCALE_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    DEFAULT: 'DEFAULT',
    DELETED: 'DELETED',
};
//# sourceMappingURL=locale-status.js.map